import { createContext, useContext, type ReactNode } from 'react'
import { useAuthStore } from '@/stores/authStore'
import type { User, Role } from '@/types'

interface AuthContextValue {
  user: User | null
  isAuthenticated: boolean
  hasRole: (role: Role | Role[]) => boolean
  logout: () => void
}

const AuthContext = createContext<AuthContextValue | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const logout = useAuthStore((s) => s.logout)

  const hasRole = (role: Role | Role[]): boolean => {
    if (!user) return false
    const userRoleLower = user.role.toLowerCase()
    if (Array.isArray(role)) return role.map(r => r.toLowerCase()).includes(userRoleLower)
    return userRoleLower === role.toLowerCase()
  }

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, hasRole, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuthContext() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuthContext deve ser usado dentro de AuthProvider')
  return ctx
}
